// ==================== API SERVICES ====================

import axios from 'axios';
import { APP_CONFIG } from '../utils/constants';

// Create axios instance for auth
const authAPI = axios.create({
  baseURL: APP_CONFIG.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: APP_CONFIG.REQUEST_TIMEOUT,
});

// Auth API Services
export const authService = {
  // Login user
  login: async (email, password) => {
    try {
      const response = await authAPI.post('/api/Auth/login', {
        Email: email,
        Password: password,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get current user info
  getCurrentUser: async token => {
    try {
      const response = await authAPI.get('/api/Auth/me', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Change password
  changePassword: async (currentPassword, newPassword, token) => {
    try {
      const response = await authAPI.post(
        '/api/Auth/change-password',
        {
          CurrentPassword: currentPassword,
          NewPassword: newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new user (Admin only)
  createUser: async (userData, token) => {
    try {
      const response = await authAPI.post(
        '/api/Auth/register',
        {
          Email: userData.email,
          Password: userData.password,
          ConfirmPassword: userData.confirmPassword,
          FirstName: userData.firstName,
          LastName: userData.lastName,
          PhoneNumber: userData.phoneNumber,
          Role: userData.role,
          OfficeLocation: userData.officeLocation || null,
          Department: userData.department || null,
          OfficeName: userData.officeName || null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all users (Admin only)
  getUsers: async token => {
    try {
      const response = await authAPI.get('/api/Auth/users', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Activate user (Admin only)
  activateUser: async (userId, token) => {
    try {
      const response = await authAPI.post(
        `/api/Auth/users/${userId}/activate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Deactivate user (Admin only)
  deactivateUser: async (userId, token) => {
    try {
      const response = await authAPI.post(
        `/api/Auth/users/${userId}/deactivate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update user profile (Admin can update any user)
  updateUserProfile: async (userId, profileData, token) => {
    try {
      const response = await authAPI.put(
        '/api/Auth/profile',
        {
          FirstName: profileData.firstName,
          LastName: profileData.lastName,
          PhoneNumber: profileData.phoneNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};
